// Servizio "documento intervento" e abbonamento SurvMaps.
// L'account è quello OmniSurv: tutte le chiamate usano il suo token.

import { BACKEND } from "./config";
import { HttpError, downloadBlob, getJson, postJson } from "./http";
import { authHeaders } from "./omnisurv";

const API = `${BACKEND}/api/docs`;

export const docsApi = {
  cities: () => getJson(`${API}/cities`),
  me: (token) => getJson(`${API}/me`, { headers: authHeaders(token) }),
  list: (token) => getJson(API, { headers: authHeaders(token) }),
  status: (token, id) => getJson(`${API}/${id}`, { headers: authHeaders(token) }),
  generate: (token, body) => postJson(`${API}/genera`, body, { headers: authHeaders(token) }),

  async download(token, id, fallbackName) {
    const res = await fetch(`${API}/${id}/pdf`, { headers: authHeaders(token) });
    if (!res.ok) throw new HttpError(res.status, "Documento non disponibile");
    const cd = res.headers.get("content-disposition") || "";
    const name = (cd.match(/filename="([^"]+)"/) || [])[1] || fallbackName || "documento_intervento.pdf";
    downloadBlob(await res.blob(), name);
  },
};

// Abbonamento al solo SurvMaps (Stripe): checkout e portale clienti.
export const subscriptionApi = {
  checkout: (token) => postJson(`${API}/abbonamento/checkout`, {}, { headers: authHeaders(token) }),
  portal: (token) => postJson(`${API}/abbonamento/portale`, {}, { headers: authHeaders(token) }),
};

// Porta l'utente al Checkout Stripe; ritorna il messaggio d'errore da mostrare, se c'è.
export async function startSubscription(token) {
  try {
    window.location.href = (await subscriptionApi.checkout(token)).url;
    return null;
  } catch (e) {
    return e.status === 503 ? "Abbonamenti SurvMaps non ancora attivi: riprova più tardi." : e.message;
  }
}
